import { render, staticRenderFns } from "./myTravelDetails.vue?vue&type=template&id=5678f1de&scoped=true&"
import script from "./myTravelDetails.vue?vue&type=script&lang=js&"
export * from "./myTravelDetails.vue?vue&type=script&lang=js&"
import style0 from "./myTravelDetails.vue?vue&type=style&index=0&id=5678f1de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5678f1de",
  null
  
)

export default component.exports